import React from 'react';

const AuctionContext = React.createContext(null);

export default AuctionContext;